export default __webpack_public_path__ + "static/media/document.72ba5d66.svg";